module.exports = __webpack_public_path__ + "static/media/federico-dorronsoro.b34773fc.jpg";